import * as React from 'react'
import { Link } from 'gatsby'
import { GiHamburgerMenu } from 'react-icons/gi';

import ScreenCrowStudiosLogoText from '../images/ScreenCrowStudiosLogoText.png'
import HeaderButton from './headerButton';

const Header = () => {
    const [toggled, setToggled] = React.useState(false);

    const burgerMenu = () => {
        setToggled(!toggled);
    };

    const closeMenu = () => {
        setToggled(false);
    };

    // HTML
    return (
        <header className='bg-black px-10 text-white flex flex-col justify-center items-center py-10'>
            <Link to='/home' className='md:my-4'>
                <img src={ScreenCrowStudiosLogoText} width='256' alt='ScreenCrow Studios home' className='md:pe-6' />
            </Link>

            <br />

            {/*Hamburger only on small screens*/}
            <button onClick={burgerMenu} aria-label='Toggle navigation' aria-expanded={toggled} className='md:hidden p-3'>
                <GiHamburgerMenu size={24} />
            </button>

            <nav className={`flex flex-col items-center overflow-hidden transition-all duration-500 md:max-h-none md:overflow-visible ${toggled ? 'max-h-screen visible' : 'max-h-0 invisible'} md:visible`}>
                <hr className='w-36 my-5 md:hidden' />

                <div className='flex flex-wrap justify-center w-36 md:w-auto md:grid md:gap-y-6 lg:flex'>
                    <HeaderButton to='/about' onClick={closeMenu} name='About' title={false} />
                    <HeaderButton to='/team' onClick={closeMenu} name='Team' title={false} />
                    <HeaderButton to='/home' onClick={closeMenu} name='Home' title={true} />
                    <HeaderButton to='/games' onClick={closeMenu} name='Games' title={false} />
                    <HeaderButton to='/contact' onClick={closeMenu} name='Contact' title={false} />
                </div>
            </nav>
        </header>
    )
}

export default Header;
